// Shared API helpers. Mixed into any component that talks to the backend
// so the Bearer-token boilerplate lives in exactly one place.
export default {
  methods: {
    authHeaders() {
      return {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
      };
    },
  },
};
